import { useEffect, useState } from 'react';

/** Search boxes wait this long after the last keystroke before searching. */
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * `value`, but only once it has stopped changing for `delayMs`. Lets a search
 * box query as the user types without a request per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = SEARCH_DEBOUNCE_MS): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
